import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import React from "react";
interface VimeoProps {
  value?: string;
  title?: string;
  description?: string;
  className?: string;
  autoplay?: boolean;
  loading?: React.IframeHTMLAttributes<HTMLIFrameElement>["loading"];
  renderDefault?: (props: any) => React.ReactNode;
}

// Helper function to extract Vimeo ID from the URL
const getVimeoId = (url: string) => {
  try {
    const Url = new URL(url);
    const potentialId = Url?.pathname.slice(1); // remove the leading "/" (slash)
    const id = potentialId ? parseInt(potentialId) : null; // id can only be a number
    return id && String(id);
  } catch {
    return null;
  }
};
export function Vimeo(t0) {
  const $ = _c(30);
  let id;
  let t1;
  let t2;
  let t3;
  let t4;
  let title;
  if ($[0] !== t0) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const {
        value,
        title: t5,
        description,
        className,
        renderDefault,
        autoplay: t6,
        loading: t7,
        ...restProps
      } = t0;
      title = t5;
      const autoplay = t6 === undefined ? false : t6;
      const loading = t7 === undefined ? "lazy" : t7;
      let t8;
      if ($[7] !== value) {
        t8 = value ? getVimeoId(value) : null;
        $[7] = value;
        $[8] = t8;
      } else {
        t8 = $[8];
      }
      id = t8;
      if (!renderDefault) {
        let t9;
        if ($[9] !== autoplay || $[10] !== id || $[11] !== loading) {
          t9 = id ? <EmbedVimeoIframe autoplay={autoplay} id={id} loading={loading} className="aspect-video w-full outline-none focus:outline-none" /> : <Placeholder message="No Vimeo Url" />;
          $[9] = autoplay;
          $[10] = id;
          $[11] = loading;
          $[12] = t9;
        } else {
          t9 = $[12];
        }
        let t10;
        if ($[13] !== className || $[14] !== t9) {
          t10 = <div className={className}>{t9}</div>;
          $[13] = className;
          $[14] = t9;
          $[15] = t10;
        } else {
          t10 = $[15];
        }
        t4 = t10;
        break bb0;
      }
      if ($[16] !== className) {
        t1 = cn("", className);
        $[16] = className;
        $[17] = t1;
      } else {
        t1 = $[17];
      }
      if ($[18] !== title) {
        t2 = title && <Title label={title} />;
        $[18] = title;
        $[19] = t2;
      } else {
        t2 = $[19];
      }
      t3 = renderDefault(restProps);
    }
    $[0] = t0;
    $[1] = id;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = title;
  } else {
    id = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    title = $[6];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[20] !== title) {
    t5 = title && <Title label={`${title} Preview`} />;
    $[20] = title;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== id) {
    t6 = id ? <EmbedVimeoIframe autoplay={false} id={id} className="aspect-video h-auto w-full outline-none focus:outline-none" /> : <Placeholder message="No Vimeo Url" />;
    $[22] = id;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t1 || $[25] !== t2 || $[26] !== t3 || $[27] !== t5 || $[28] !== t6) {
    t7 = <div className={t1}>{t2}{t3}{t5}{t6}</div>;
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    t7 = $[29];
  }
  return t7;
}

// Title Component
const Title = t0 => {
  const $ = _c(2);
  const {
    label
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <div className="py-2"><span className="text-sm font-semibold">{label}</span></div>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};

// Vimeo Iframe Embed Component
const EmbedVimeoIframe = React.forwardRef<HTMLIFrameElement, {
  id: string;
  autoplay: boolean;
} & Omit<React.IframeHTMLAttributes<HTMLIFrameElement>, "src">>((t0, ref) => {
  const $ = _c(12);
  let autoplay;
  let id;
  let iframeProps;
  if ($[0] !== t0) {
    ({
      id,
      autoplay,
      ...iframeProps
    } = t0);
    $[0] = t0;
    $[1] = autoplay;
    $[2] = id;
    $[3] = iframeProps;
  } else {
    autoplay = $[1];
    id = $[2];
    iframeProps = $[3];
  }
  const base = `https://player.vimeo.com/video/${id}`;
  const src = autoplay ? `${base}?autoplay=1&muted=0` : base;
  const t1 = iframeProps.loading ?? "lazy";
  const t2 = iframeProps.title ?? id;
  const t3 = iframeProps.allow ?? "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share";
  const t4 = iframeProps.allowFullScreen ?? true;
  let t5;
  if ($[4] !== iframeProps || $[5] !== ref || $[6] !== src || $[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <iframe ref={ref} {...iframeProps} src={src} loading={t1} title={t2} allow={t3} allowFullScreen={t4} />;
    $[4] = iframeProps;
    $[5] = ref;
    $[6] = src;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
});
EmbedVimeoIframe.displayName = "EmbedVimeoIframe";

// Placeholder Component
const Placeholder = t0 => {
  const $ = _c(10);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message) {
    t1 = <title>{message}</title>;
    $[0] = message;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M12 18.75H4.5a2.25 2.25 0 01-2.25-2.25V9m12.841 9.091L16.5 19.5m-1.409-1.409c.407-.407.659-.97.659-1.591v-9a2.25 2.25 0 00-2.25-2.25h-9c-.621 0-1.184.252-1.591.659m12.182 12.182L2.909 5.909M1.5 4.5l1.409 1.409" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={0.8} stroke="currentColor" className="h-12 w-12">{t1}{t2}</svg>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== message) {
    t4 = <span className="text-sm font-semibold">{message}</span>;
    $[5] = message;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className="flex aspect-video flex-col items-center justify-center gap-4 border border-gray-400/50">{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};